<template>
  <div class="searchList">
    <div class="box-content">
      <label class="form-tit">订单编号</label>
      <el-input
        v-model="searchData.order_no"
        class="jm-input280"/>
    </div>
    <div class="box-content">
      <label class="form-tit">订单名称</label>
      <el-input
        v-model="searchData.order_title"
        class="jm-input280"/>
    </div>
    <div class="box-content">
      <label class="form-tit">最后付款日期</label>
      <el-date-picker
        class="jm-input280"
        v-model="searchData.last_payment_date"
        type="daterange"
        value-format="yyyy-MM-dd"
        range-separator="-"
        start-placeholder="开始日期"
        end-placeholder="结束日期">
      </el-date-picker>
    </div>
    <div class="box-content">
      <label class="form-tit">是否缴齐</label>
      <jm-dict-select
        class="jm-input280"
        clearable
        v-model="searchData.order_status"
        type="training"
        dict-type="order_status"
        value-type="string"
        name="order_status"/>
    </div>
    <div class="box-content">
      <label class="form-tit">学生姓名</label>
      <el-input
        v-model="searchData.custom_name"
        class="jm-input280"/>
    </div>
    <div class="box-content">
      <label class="form-tit">电话号码</label>
      <el-input
        v-model="searchData.crm_tel"
        class="jm-input280"/>
    </div>
    <div class="box-content">
      <label class="form-tit">发起人:</label>
      <el-select
        v-model="searchData.create_uid"
        filterable
        class="jm-input280"
        placeholder="请选择">
        <el-option-group
          v-for="(group, k) in pageDs.create_list"
          :key="k"
          :label="k">
          <el-option
            v-for="item in group"
            v-show="item.userid > 0"
            :key="item.userid"
            :label="item['username']"
            :value="item['userid']"/>
        </el-option-group>
      </el-select>
    </div>
    <div class="box-content">
      <label class="form-tit">创建时间</label>
      <el-date-picker
        class="jm-input280"
        v-model="searchData.create_time"
        type="daterange"
        value-format="yyyy-MM-dd"
        range-separator="-"
        start-placeholder="开始日期"
        end-placeholder="结束日期">
      </el-date-picker>
    </div>
    <div class="box-content">
      <label class="form-tit">学生编码</label>
      <el-input
        v-model="searchData.crm_id"
        class="jm-input280"/>
    </div>
    <div class="box-content box-content-span">
      <label class="form-tit">所申学校:</label>
      <school-multiple-search
        placeholder="请输入学校关键字"
        :default-options.sync="searchData.apply_school_list"
        @change="schoolChange"
        :country-sh-mg-id="0"
        :value.sync="searchData.apply_school_ids"></school-multiple-search>
      <span class="tip-text">如学生未确定学校无需填写</span>
    </div>
    <div class="box-content box-content-span">
      <label class="form-tit">入学时间:</label>
      <el-date-picker
        v-model="searchData.custom_year"
        type="year"
        format="yyyy"
        value-format="yyyy"
        placeholder="请选择"
        ref="customer_year"
        class="moremode"
        :editable="false"
      />
      <el-date-picker
        :disabled="!searchData.custom_year"
        v-model="searchData.custom_month"
        format="MM"
        value-format="MM"
        type="month"
        placeholder="请选择"
        popper-class="process-list-popper"
        class="moremode"
        :editable="false"
      />
    </div>
  </div>
</template>
<script>
import { formatSelectGroupData } from '@/utils/utils.js';
import schoolMultipleSearch from '@/components/tool/select/schoolMultipleSearch';

function initSearchData() {
  return {
    order_no: '',
    order_title: '',
    last_payment_time: [],
    order_status: '',
    custom_name: '',
    crm_tel: '',
    create_time: [],
    crm_id: '',
    site_name: 'training',
    apply_school_list: [],
    apply_school_ids: [],
    custom_year: '',
    custom_month: '',
    create_uid: ''
  };
}
export default {
  props: {
    searchData: {
      type: Object,
      default: initSearchData(),
    },
  },
  data() {
    return {
      classes: [],
      pageDs: {}
    };
  },
  methods: {
    initSearchData() {
      return initSearchData();
    },
    schoolChange(val) {
      this.searchData.apply_school_ids = val;
    }
  },
  components: {
    schoolMultipleSearch,
  },
  mounted() {
    this.$http._post({
      url: '/index/jm.order2022/SearchDs'
    }).then(({ data }) => {
      this.pageDs = data;
      this.pageDs.create_list = formatSelectGroupData(data.create_list);
    }).catch((res) => {
      console.log(res);
    });
  },
  watch: {
    searchData: {
      handler: function (newValue) {
        this.$emit('update:searchData', newValue);
      },
      deep: true
    }
  }
};
</script>
